import { canonicalAndHreflang } from "@/lib/hreflang";
import { ctrDesc, ctrTitle } from "@/lib/seo-copy";
import { createFileRoute, Link } from "@tanstack/react-router";
import { SITE } from "@/lib/site-config";
import { PageHero } from "@/components/PageHero";
import {
  buildJsonLd,
  jsonLdScript,
  webPageSchema,
  breadcrumbListSchema,
  faqPageSchema,
  organizationSchema,
} from "@/lib/schema";

const FAQS = [
  {
    question: "Notary Public ในประเทศไทยคือใคร ต้องเป็นทนายไหม?",
    answer:
      "ในประเทศไทย ผู้ทำหน้าที่ Notary Public เรียกว่า Notarial Services Attorney ต้องเป็นทนายความที่ได้รับใบอนุญาตจากสภาทนายความในพระบรมราชูปถัมภ์ ตามข้อบังคับ พ.ศ. 2551 เท่านั้น ทีมงานของเราทั้ง 6 ท่านเป็นทนายที่ได้รับใบอนุญาตอย่างถูกต้อง",
  },
  {
    question: "เอกสารที่รับรอง Notary แล้วใช้ต่างประเทศได้ทันทีไหม?",
    answer:
      "ข้อกำหนดขึ้นกับประเทศ หน่วยงานปลายทาง และชนิดเอกสาร บางกรณีอาจต้องผ่านกรมการกงสุล กระทรวงการต่างประเทศ หรือสถานทูตเพิ่มเติม จึงควรตรวจข้อกำหนดกับหน่วยงานผู้รับเอกสารก่อนดำเนินการ",
  },
  {
    question: "ค่าใช้จ่ายคิดอย่างไร และขอใบเสนอราคาได้ทางไหน?",
    answer:
      "เราคิดค่าบริการตามงานจริง (ประเภทเอกสาร จำนวนฉบับ/หน้า คู่ภาษา ความเร่งด่วน และเส้นทางรับรองต่อ) จึงไม่ประกาศราคาเดียวบนเว็บ ส่งภาพเอกสารและชื่อหน่วยงานปลายทางมาทาง โทร 094-895-8999 · LINE @Thainotary หรืออีเมล เจ้าหน้าที่จะแจ้งค่าบริการและกำหนดเสร็จให้ก่อนเริ่มงาน ค่าธรรมเนียมราชการเรียกเก็บตามอัตราของหน่วยงานตามจริง",
  },
  {
    question: "ใช้เวลานานไหม?",
    answer:
      "ระยะเวลาขึ้นกับประเภทและจำนวนเอกสาร คู่ภาษา การตรวจต้นฉบับ ขั้นตอนของหน่วยงานรัฐหรือสถานทูต และข้อกำหนดของหน่วยงานปลายทาง โปรดส่งเอกสารให้เจ้าหน้าที่ตรวจเพื่อแจ้งระยะเวลาประมาณการก่อนเริ่มงาน",
  },
  {
    question: "ให้บริการนอกกรุงเทพหรือไม่?",
    answer:
      "มีสำนักงานจริง 4 สาขา ได้แก่ กรุงเทพฯ (วังทองหลาง) ขอนแก่น อุดรธานี และหนองคาย และมีเครือข่ายทนายพันธมิตรครอบคลุม 77 จังหวัด รับงาน Notary นอกสถานที่ได้ตามข้อตกลง",
  },
  {
    question: "ให้บริการภาษาอะไรบ้าง?",
    answer:
      "แปลและรับรองภาษาหลักได้กว่า 40 ภาษา รวมถึง ไทย อังกฤษ จีน (กลาง/กวางตุ้ง) ญี่ปุ่น เกาหลี เยอรมัน ฝรั่งเศส สเปน อิตาลี รัสเซีย เวียดนาม อินโดนีเซีย มลายู อาหรับ ฯลฯ พร้อมล่ามในสายกฎหมายและธุรกิจ",
  },
  {
    question: "รับชำระเงินอย่างไร?",
    answer:
      "รับชำระผ่านโอนธนาคาร (SCB, KBank, BBL) พร้อมเพย์ QR code บัตรเครดิต/เดบิต และเงินสดที่สำนักงาน สามารถออกใบกำกับภาษีในนามบริษัทได้",
  },
  {
    question: "เอกสารที่รับรองแล้วเก็บไว้กี่ปี? ปลอดภัยไหม?",
    answer:
      "สำนักงานใช้มาตรการคุ้มครองข้อมูลตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ระยะเวลาและเหตุผลในการเก็บเอกสารขึ้นกับประเภทงานและฐานกฎหมายที่เกี่ยวข้อง โปรดสอบถามเจ้าหน้าที่หากต้องการใช้สิทธิหรือขอรายละเอียดการเก็บรักษา",
  },
  {
    question: "ทำ Notary ต้องเซ็นต่อหน้าทนายเสมอไหม?",
    answer:
      "กรณีรับรองลายมือชื่อ ผู้รับรองต้องตรวจยืนยันตัวบุคคลและการลงลายมือชื่อตามรูปแบบงานที่เกี่ยวข้อง จึงควรสอบถามผู้รับเอกสารและทนายผู้ดำเนินการก่อนลงนาม หากอยู่ต่างประเทศให้ตรวจวิธีรับรองกับสถานทูตไทยหรือหน่วยงานท้องถิ่นของประเทศนั้น",
  },
  {
    question: "คนต่างชาติใช้บริการได้ไหม?",
    answer:
      "ได้แน่นอน เราให้บริการชาวต่างชาติเป็นประจำ ทั้งการรับรองเอกสารเพื่อใช้ที่ประเทศต้นทาง วีซ่า Work Permit จดทะเบียนสมรส จดบริษัท BOI และบริการ Expat Concierge ทีมงานสื่อสารภาษาอังกฤษได้",
  },
  {
    question: "หากยื่นแล้วสถานทูตไม่รับ ทำอย่างไร?",
    answer:
      "โปรดส่งหนังสือหรือเหตุผลที่หน่วยงานแจ้งกลับมาให้เจ้าหน้าที่ตรวจ เพราะการไม่รับเอกสารอาจเกิดจากรูปแบบคำแปล ขั้นตอนรับรอง อายุเอกสาร หรือข้อกำหนดเฉพาะของหน่วยงานปลายทาง แนวทางแก้ไขและค่าใช้จ่ายจะประเมินตามสาเหตุจริง",
  },
  {
    question: "จองคิว/ปรึกษาฟรีอย่างไร?",
    answer:
      "ติดต่อทาง LINE @Thainotary โทร 094-895-8999 ในเวลาทำการ หรืออีเมลพร้อมส่งภาพเอกสาร ชื่อประเทศและหน่วยงานปลายทาง และวันที่ต้องการใช้ เจ้าหน้าที่จะตรวจรายละเอียดเพื่อแจ้งขั้นตอนและใบเสนอราคา",
  },
];

const TITLE = "คำถามที่พบบ่อย — Notary Public, แปลรับรอง, วีซ่า | Thai Notary Law";
const DESC =
  "รวมคำถาม-คำตอบเกี่ยวกับบริการ Notary Public ในประเทศไทย ค่าใช้จ่าย ระยะเวลา การรับรองต่อกงสุลและสถานทูต พร้อมคำแนะนำจากทนายผู้ได้รับใบอนุญาต";

export const Route = createFileRoute("/faq")({
  component: FAQ,
  loader: () => ({ h: (() => ({
    meta: [
      { title: ctrTitle(TITLE) },
      { name: "description", content: ctrDesc(DESC) },
      { property: "og:title", content: ctrTitle(TITLE) },
      { property: "og:description", content: ctrDesc(DESC) },
      { property: "og:type", content: "website" },
    ],
    links: canonicalAndHreflang("/faq"),
    scripts: [
      jsonLdScript(
        buildJsonLd([
          organizationSchema(),
          webPageSchema({ url: "/faq", title: TITLE, description: DESC, speakable: true }),
          breadcrumbListSchema([
            { name: "หน้าแรก", url: "/" },
            { name: "คำถามที่พบบ่อย", url: "/faq" },
          ]),
          faqPageSchema(FAQS),
        ]),
      ),
    ],
  }))() }),
  head: ({ loaderData }) => loaderData?.h ?? {},
});

function FAQ() {
  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title={
          <>
            คำถามที่ <span className="text-[var(--gold)]">พบบ่อย</span> เกี่ยวกับบริการของเรา
          </>
        }
        subtitle="รวมคำตอบจากทนาย Notary Public พร้อมข้อกำหนดล่าสุดของสภาทนายความ กรมการกงสุล และสถานทูตหลัก"
        primaryCta={{ label: "ปรึกษาเพิ่มเติมทางไลน์", href: SITE.contact.lineUrl }}
        secondaryCta={{ label: `โทร ${SITE.contact.phone}`, href: `tel:${SITE.contact.phone}` }}
        badges={["Updated 2026", "ตอบโดยทนายผู้ได้รับใบอนุญาต"]}
      />

      <section className="mx-auto max-w-3xl px-4 py-16">
        <dl className="space-y-4">
          {FAQS.map((f, i) => (
            <details
              key={f.question}
              open={i < 3}
              className="group rounded-xl border border-border bg-card p-6 open:border-[var(--gold)] open:shadow-[var(--shadow-elegant)]"
            >
              <summary className="flex cursor-pointer items-start justify-between gap-4 list-none">
                <dt className="text-base font-semibold text-foreground group-open:text-[var(--primary)]">
                  {i + 1}. {f.question}
                </dt>
                <span className="mt-1 text-[var(--gold)] transition-transform group-open:rotate-45">+</span>
              </summary>
              <dd className="mt-3 text-sm leading-relaxed text-muted-foreground">{f.answer}</dd>
            </details>
          ))}
        </dl>

        <div className="mt-12 border-t border-border pt-8">
          <h2 className="text-xl font-bold text-foreground">แหล่งข้อมูลทางการและบริการที่เกี่ยวข้อง</h2>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
            ข้อกำหนดอาจเปลี่ยนแปลงและแตกต่างตามปลายทาง ควรตรวจข้อมูลล่าสุดจากหน่วยงานผู้รับเอกสารก่อนยื่นจริง
          </p>
          <ul className="mt-5 grid gap-3 text-sm sm:grid-cols-2">
            <li><a href="https://www.lawyerscouncil.or.th/" target="_blank" rel="noopener noreferrer" className="text-[var(--primary)] hover:underline">สภาทนายความในพระบรมราชูปถัมภ์ ↗</a></li>
            <li><a href="https://consular.mfa.go.th/" target="_blank" rel="noopener noreferrer" className="text-[var(--primary)] hover:underline">กรมการกงสุล กระทรวงการต่างประเทศ ↗</a></li>
            <li><a href="https://www.pdpc.or.th/" target="_blank" rel="noopener noreferrer" className="text-[var(--primary)] hover:underline">สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล ↗</a></li>
            <li><Link to="/services" className="text-[var(--primary)] hover:underline">ดูบริการทั้งหมด →</Link></li>
            <li><Link to="/notary" className="text-[var(--primary)] hover:underline">บริการ Notary Public →</Link></li>
            <li><Link to="/contact" className="text-[var(--primary)] hover:underline">ส่งเอกสารให้เจ้าหน้าที่ประเมิน →</Link></li>
          </ul>
        </div>
      </section>
    </>
  );
}
